.seat {
  position: absolute;
  z-index: 3;
  translate: -50% -50%;
  display: grid;
  justify-items: center;
  gap: 4px;
  width: 110px;
  pointer-events: auto;
}

.seat[data-online='false'] .avatar {
  filter: grayscale(1) brightness(0.6);
}

.avatar {
  position: relative;
  transition: filter 0.4s;
}

.seat[data-you='true'] .avatar {
  border-radius: 50%;
  box-shadow:
    0 0 0 3px var(--color-accent),
    0 0 24px rgb(232 184 79 / 0.45);
}

.crown {
  position: absolute;
  top: -10px;
  left: 50%;
  translate: -50% 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: var(--color-accent);
  color: var(--color-accent-ink);
  box-shadow: 0 2px 8px rgb(0 0 0 / 0.4);
}

.name {
  max-width: 100%;
  padding: 2px 10px;
  border-radius: 999px;
  background: rgb(0 0 0 / 0.55);
  backdrop-filter: blur(6px);
  font-size: 0.82rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.you {
  color: var(--color-accent);
  font-weight: 500;
}

.status {
  font-size: 0.7rem;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.menuAnchor {
  position: relative;
}

.menuButton {
  all: unset;
  display: block;
  cursor: pointer;
  border-radius: 50%;
  transition: transform 0.2s var(--ease-out);
}

.menuButton:hover {
  transform: scale(1.06);
}

.menuButton:focus-visible {
  outline: 2px solid var(--color-accent-strong);
  outline-offset: 3px;
}

.menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  z-index: 20;
  translate: -50% 0;
  min-width: 220px;
  margin: 0;
  padding: 6px;
  list-style: none;
  border-radius: var(--radius);
  background: rgb(18 26 23 / 0.97);
  border: 1px solid var(--color-border);
  box-shadow: 0 18px 40px rgb(0 0 0 / 0.55);
  transform-origin: top center;
}

.menuItem {
  all: unset;
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 9px 12px;
  border-radius: var(--radius-small);
  font-size: 0.9rem;
  cursor: pointer;
}

.menuItem:hover,
.menuItem:focus-visible {
  background: var(--color-surface-strong);
}
